export default "__VITE_ASSET__a76824d1__"